"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonApi = void 0;
/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
const axios_1 = __importDefault(require("axios"));
class TonApi {
    constructor() {
        this._url = 'https://tonapi.io/v2/'; // https://king-prawn-app-situq.ondigitalocean.app
        // private _url: string = 'https://tonapi.delabteam.com/' // https://tonapi.io/v2/
        this._token = 'AFJOFCU7U3SD7DYAAAAFNHSJF3J4OKQQEXIMHCEQSXUQJAGVP227ZLZ3G3MQTBEU5P3JMRI';
    }
    async send(url, data) {
        const res = await axios_1.default.get(`${this._url}${url}?${new URLSearchParams(data)}`, { headers: { Authorization: `Bearer ${this._token}` } });
        if (res.data.error) {
            console.error(res.data.result);
            return undefined;
        }
        return res.data;
    }
    async get(url, data, headers = {}) {
        // let urlFull;
        // if (this._network === 'mainnet') {
        //   urlFull = this._url;
        // }
        // if (this._network === 'testnet') {
        //   urlFull = this._urlTest;
        // }
        const urlFull = 'https://tonapi.io/v2/';
        const config = {
            headers: {
                ...headers,
                Authorization: `Bearer ${this._token}`
            }
        };
        const res = await axios_1.default.get(`${urlFull}${url}?${new URLSearchParams(data)}`, config);
        if (res.data.error) {
            console.error(res.data.result);
            return undefined;
        }
        return res.data;
    }
    async getAllNftItems(account_id, collection, limit, offset, indirect_ownership) {
        const data = {};
        if (collection !== undefined) {
            data.collection = collection;
        }
        if (limit !== undefined) {
            data.limit = limit;
        }
        if (offset !== undefined) {
            data.offset = offset;
        }
        if (indirect_ownership !== undefined) {
            data.indirect_ownership = indirect_ownership;
        }
        const result = await this.send(`accounts/${account_id}/nfts`, data);
        console.log(result);
        return result;
    }
    async getHumanFriendlyInfo(account_id) {
        const data = await this.send(`accounts/${account_id}`, {});
        console.log(data);
        return data;
    }
    async getTokenPrice(tokens, currencies) {
        const data = await this.send('rates', { tokens, currencies });
        return data;
    }
    async getAddressByDomainName(domain_name) {
        const data = await this.send(`/dns/${domain_name}/resolve`, {});
        console.log(data);
        return data;
    }
    async getAllJettonsBalances(account_id, currencies) {
        const data = {};
        if (currencies !== undefined) {
            data.currencies = currencies;
        }
        const result = await this.send(`accounts/${account_id}/jettons`, data);
        console.log(result);
        return result;
    }
    async getChartToken(token, currency, start_date, end_date) {
        const data = { token };
        if (currency !== undefined) {
            data.currency = currency;
        }
        if (start_date !== undefined) {
            data.start_date = start_date;
        }
        if (end_date !== undefined) {
            data.end_date = end_date;
        }
        const result = await this.send('rates/chart', data);
        console.log(result);
        return result;
    }
    async getTransactions(block_id, limit) {
        const data = { limit };
        const res = await this.send(`blockchain/accounts/${block_id}/transactions`, data);
        console.log(res);
        return res;
    }
    async getTransferJettonHistory(account_id, jetton_id, limit, before_it, start_date, end_date) {
        const data = { limit };
        if (before_it !== undefined) {
            data.before_it = before_it;
        }
        if (start_date !== undefined) {
            data.start_date = start_date;
        }
        if (end_date !== undefined) {
            data.end_date = end_date;
        }
        const result = await this.send(`accounts/${account_id}/jettons/${jetton_id}/history`, data);
        console.log(result);
        return result;
    }
    async getWalletInfo(account_id) {
        const result = await this.send(`accounts/${account_id}`, {});
        console.log('TONAPI getWalletInfo', result);
        return result;
    }
    async getEventsAccount(account_id, limit, accept_language, initiator, subject_only, before_lt, start_date, end_date) {
        const data = { limit };
        const headers = {};
        if (accept_language !== undefined) {
            headers['Accept-Language'] = accept_language;
        }
        if (initiator !== undefined) {
            data.initiator = initiator;
        }
        if (subject_only !== undefined) {
            data.subject_only = subject_only;
        }
        if (before_lt !== undefined) {
            data.before_lt = before_lt;
        }
        if (start_date !== undefined) {
            data.start_date = start_date;
        }
        if (end_date !== undefined) {
            data.end_date = end_date;
        }
        const result = await this.get(`accounts/${account_id}/events`, data, headers);
        console.log(result);
        return result;
    }
}
exports.TonApi = TonApi;
